import { navigateToCompetitionTab } from './navigate-to-competition-tab';
import { navigateToLegacyAuctionInsights } from './navigate-to-legacy-auction-insights';

function getNavigate(pluginConfig) {
  const {
    shouldNavigateToCompetitionTab,
  } = pluginConfig;

  const navigate = shouldNavigateToCompetitionTab ?
    navigateToCompetitionTab : navigateToLegacyAuctionInsights;

  return navigate;
}

export function onClickSelected(pluginConfig, gridView, crossPageSelectAll) {
  const { crossPageSelectNotAllowedI18nKey, i18n } = pluginConfig;
  const selectedItems = gridView.selectedItems();

  // must have at least 1 selected item
  if (selectedItems.length < 1) {
    alert(i18n.getString('Grid_RowSelectionRequired')); // eslint-disable-line no-alert
    return;
  }

  // cross-page select not supported
  // prompt user if they want to continue with just visible selected items
  if (crossPageSelectAll.isAllSelected) {
    // eslint-disable-next-line no-alert,no-restricted-globals
    if (!confirm(i18n.getString(crossPageSelectNotAllowedI18nKey))) {
      return;
    }
  }

  const navigate = getNavigate(pluginConfig);

  navigate(pluginConfig, selectedItems);
}

/**
 * Gets the menu items for Auction Insight.
 * @param {Object} pluginConfig - Configuration object.
 * @param {Object} gridView - Projection grid view.
 * @param {Object} crossPageSelectAll - Cross-page select all grid plugin.
 * @returns {Object[]} Array of dropdown menu items: header and two buttons with click handlers.
 */
export function getDropdownMenuItems(pluginConfig, gridView, crossPageSelectAll) {
  const {
    i18n,
    state,
    legacyRouter,
    scope,
    shouldNavigateToCompetitionTab,
    preferenceService,
    permissions,
  } = pluginConfig;

  // validate pluginConfig
  let isPluginConfigValid = true;
  if (shouldNavigateToCompetitionTab) {
    isPluginConfigValid =
      i18n && legacyRouter && scope && preferenceService && permissions;
  } else {
    isPluginConfigValid = i18n && legacyRouter && state;
  }

  if (!isPluginConfigValid) {
    throw new Error('auction insight plugin config does not meet the requirement');
  }

  const navigate = getNavigate(pluginConfig);

  return [{
    type: 'dropdown-header',
    text: i18n.getString('Grid_AuctionInsightsButtonText'),
  }, {
    text: i18n.getString('Grid_AuctionInsightsSelectedButtonText'),
    onClick: () => onClickSelected(pluginConfig, gridView, crossPageSelectAll),
    classes: ['auction-insight-selected'],
  }, {
    text: i18n.getString('Grid_AuctionInsightsAllButtonText'),
    onClick: () => navigate(pluginConfig),
    classes: ['auction-insight-all'],
  }];
}
